import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { isbot } from 'isbot';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly window = inject<Window>(WA_WINDOW);

  public get isPlatformBrowserBot() {
    return isbot(this.window?.navigator?.userAgent);
  }

  public get isPlatformServer() {
    return isPlatformServer(this.platformId);
  }

  public get isPlatformBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  public get isTrackable() {
    return this.isPlatformBrowser && !this.isPlatformBrowserBot;
  }
}
